export default __webpack_public_path__ + "static/media/go-a.f62f1bef.png";